module.exports = __webpack_public_path__ + "media/images/categories/headers/international-politics-b89d5b718a36d68c4190a757e486e7ed.jpg";